var _clipPath, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgCheckmarki = function SvgCheckmarki(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-.03 -.03)"
  }, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "checkmark_i_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.03.03h23.972v23.983H.03z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#checkmark_i_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: props.color || 'currentColor',
    fillRule: "nonzero",
    d: "M12.016 24.021c6.627 0 12-5.373 12-12s-5.373-12-12-12-12 5.373-12 12 5.373 12 12 12z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M17.751 8.329a1 1 0 0 1-.011 1.414l-6.094 6a1 1 0 0 1-1.404 0l-3.906-3.847a1 1 0 1 1 1.404-1.425l3.204 3.156 5.392-5.309a1 1 0 0 1 1.415.011z"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCheckmarki);
export default ForwardRef;